import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import Spinner from "../../components/Reuseable/Spinner";
const ProfileComponent = loadable(() => import("../../components/Profile"));
type Props = {};

const Profile = (props: Props) => {
  const { data: profileData, isPending: profileDataLoading } = useGetHook({
    queryKey: ["profile"],
    url: `${APIS.PROFILE}`,
    params: {},
  });
  return (
    <>
      {profileDataLoading ? (
        <Spinner />
      ) : (
        <ProfileComponent profileData={profileData} />
      )}
    </>
  );
};

export default Profile;
